import React from "react";
import PropTypes from "prop-types";
import { useFormikContext } from "formik";
import { TextField } from "@material-ui/core";

import "./ClientNameInput.scss";

const ClientNameInput = ({ field, isEdit, generateCodeFromName, ...props }) => {
  const form = useFormikContext();
  const { errors, touched, setFieldValue, setFieldTouched } = form;

  const onChange = (event) => {
    setFieldValue(field.name, event.target.value);
  };

  const handleBlur = (event) => {
    setFieldTouched(field.name, true);
    
    if (!isEdit && !form.values.codeManuallyEdited && !form.values.code) {
      const suggestedCode = generateCodeFromName(event.target.value);
      setFieldValue("code", suggestedCode);
    }
  };

  return (
    <TextField
      {...props}
      {...field}
      onChange={onChange}
      onBlur={handleBlur}
      value={field.value || ""}
      className="form-input client-name-input"
      color="secondary"
      error={props.error || !!(touched[field.name] && errors[field.name])}
      helperText={
        props.helperText ||
        (touched[field.name] &&
          errors[field.name] &&
          errors[field.name])
      }
    />
  );
};

ClientNameInput.propTypes = {
  field: PropTypes.object.isRequired,
  isEdit: PropTypes.bool,
  generateCodeFromName: PropTypes.func.isRequired,
};

export default ClientNameInput;

